<template>
  <div>
    <b-row style="margin-bottom: 10px;">
      <b-col class="text-center">
        <b-button @click="cropImage" variant="primary" v-if="!croppedImage">
          Cortar Imagem
        </b-button>
        <b-button variant="warning" @click="restartCropping" v-if="croppedImage">
          Fazer Novamente
        </b-button>
        <b-button variant="success" @click="finishCropping" v-if="croppedImage" style="margin-left: 10px;">
          Confirmar
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="imgUrl && !croppedImage">
      <b-col class="text-center">
        <img style="max-width: 50%; max-height: 50%;" id="image" :src="imgUrl" />
      </b-col>
    </b-row>
    <b-row v-else-if="croppedImage">
      <b-col class="text-center">
        <div>
          <img style="max-width: 50%; margin-left: 25%" :src="croppedImage">
        </div>
      </b-col>
    </b-row>
  </div>
</template>
 <style scoped>
    img {
        display: block;

        /* This rule is very important, please don't ignore this */
        max-width: 100%;
    }
</style>

<script>
import service from "../service";
import Router from "vue-router";
import { isMobile } from "mobile-device-detect";
import Config from "../config";
import axios from 'axios'
//import VueCropper from "vue-cropperjs"

export default {
  name: "ImageCropper",
  props: {
    imgUrl: "",
    croppingRatio: undefined
  },
  data: function() {
    return {      
      isMobile: isMobile,
      croppedImage: undefined,
      cropper: undefined
    };
  },
  //components: { VueCropper },
  computed: {
    
  },
  methods: {
    finishCropping: function() {
      this.$emit('croppingFinished', {dataUrl : this.croppedImage});
    },
    cropImage: function() {
      this.croppedImage = this.cropper.getCroppedCanvas().toDataURL('image/png');
      this.cropper.destroy();
    },
    startCropping: function() {
      const image = document.getElementById('image');
      this.cropper = new Cropper(image, {
          aspectRatio: this.croppingRatio,
          crop(event) {
              /*console.log(event.detail.x);
              console.log(event.detail.y);
              console.log(event.detail.width);
              console.log(event.detail.height);
              console.log(event.detail.rotate);
              console.log(event.detail.scaleX);
              console.log(event.detail.scaleY);*/
          }
      });

      image.addEventListener('ready', function () {
        this.cropper.zoom(-0.2);
      });
    },
    restartCropping: function() {
      this.croppedImage = false;
      setTimeout(this.startCropping, 150);
    }
  },
  mounted: function() {
    this.startCropping();
  }
};
</script>


<style lang="scss">
  @import '../assets/styles/cropper.css';
.margin-bot {
  margin-bottom: 30px !important;
}
</style>